import axios from 'axios';
import _ from 'lodash';

export const state = {
    ticket: null,
    isLoading: false,
    isLoadingAgents: false,
    serverErrors: [],
    updateKey: 1,
    timelineUpdateKey: 1,

    selectedAction: null, // ['reply', 'add-note', 'forward'],
    sidebarSection: null,

    isLoadingIfCanClaimTicket: false,
    canClaimTicket: null,

    isLoadingTagTemplates: null,
    tagTemplates: null,

    isLoadingAxumData: null,
    axumData: null,

    isLoadingMedia: false,
    media: null,

    isLoadingExpenses: false,
    expenses: null,

    isLoadingAudits: false,
    audits: null,

    isLoadingOfficeTransfers: false,
    officeTransfers: [],

    isLoadingRelatedTickets: false,
    relatedTickets: null,

    showDeleted: false
}

export const mutations = {
    START_LOADING(state) {
        state.isLoading = true;
    },

    STOP_LOADING(state) {
        state.isLoading = false;
    },

    START_LOADING_IF_CAN_CLAIM_TICKET(state) {
        state.isLoadingIfCanClaimTicket = true;
    },

    STOP_LOADING_IF_CAN_CLAIM_TICKET(state) {
        state.isLoadingIfCanClaimTicket = false;
    },

    SET_CAN_CLAIM_TICKET(state, val) {
        state.canClaimTicket = val;
    },

    START_LOADING_AGENTS(state) {
        state.isLoadingAgents = true;
    },

    STOP_LOADING_AGENTS(state) {
        state.isLoadingAgents = false;
    },

    START_LOADING_AXUM_DATA(state) {
        state.isLoadingAxumData = true;
    },

    STOP_LOADING_AXUM_DATA(state) {
        state.isLoadingAxumData = false;
    },

    START_LOADING_MEDIA(state) {
        state.isLoadingMedia = true;
    },

    STOP_LOADING_MEDIA(state) {
        state.isLoadingMedia = false;
    },

    START_LOADING_EXPENSES(state) {
        state.isLoadingExpenses = true;
    },

    STOP_LOADING_EXPENSES(state) {
        state.isLoadingExpenses = false;
    },

    START_LOADING_AUDITS(state) {
        state.isLoadingAudits = true;
    },

    STOP_LOADING_AUDITS(state) {
        state.isLoadingAudits = false;
    },

    START_LOADING_OFFICE_TRANSFERS(state) {
        state.isLoadingOfficeTransfers = true;
    },

    STOP_LOADING_OFFICE_TRANSFERS(state) {
        state.isLoadingOfficeTransfers = false;
    },

    START_LOADING_RELATED_TICKETS(state) {
        state.isLoadingRelatedTickets = true;
    },

    STOP_LOADING_RELATED_TICKETS(state) {
        state.isLoadingRelatedTickets = false;
    },

    START_LOADING_TAG_TEMPLATES(state) {
        state.isLoadingTagTemplates = true;
    },

    STOP_LOADING_TAG_TEMPLATES(state) {
        state.isLoadingTagTemplates = false;
    },

    SET_TICKET(state, ticket) {
        state.ticket = ticket;
    },

    SET_AGENTS(state, agents) {
        state.agents = agents;
    },

    SET_AXUM_DATA(state, axumData) {
        state.axumData = axumData;
    },

    SET_MEDIA(state, media) {
        state.media = media;
    },

    SET_EXPENSES(state, expenses) {
        state.expenses = expenses;
    },

    SET_AUDITS(state, audits) {
        state.audits = audits;
    },

    SET_OFFICE_TRANSFERS(state, officeTransfers) {
        state.officeTransfers = officeTransfers;
    },

    SET_TAG_TEMPLATES(state, tagTemplates) {
        state.tagTemplates = tagTemplates;
    },

    SET_RELATED_TICKETS(state, relatedTickets) {
        state.relatedTickets = relatedTickets;
    },

    SET_ERRORS(state, errors) {
        state.serverErrors = errors;
    },

    SET_SELECTED_ACTION(state, selectedAction) {
        state.selectedAction = selectedAction;
    },

    INCREMENT_UPDATE_KEY(state) {
        state.updateKey = state.updateKey + 1;
    },

    INCREMENT_TIMELINE_UPDATE_KEY(state) {
        state.timelineUpdateKey = state.timelineUpdateKey + 1;
    },

    UPDATE_TICKET_PROPERTY_SILENTLY(state, params) {
        state.ticket[params.property] = params.value;
        if (params.property === 'agent_id') {
            state.ticket['agent'] = _.find(state.agents, {
                id: params.value
            });
        }
    },

    SET_SIDEBAR_SECTION(state, section) {
        state.sidebarSection = section;
    },

    SET_SHOW_DELETED(state, val) {
        state.showDeleted = val;
    },

    UPDATE_LOCAL_TASK(state, task) {
        let taskIndex = _.findIndex(state.ticket.tasks, {
            id: task.id
        });
        if (taskIndex !== -1) {
            state.ticket.tasks[taskIndex] = task;
        }
    }
}

export const getters = {
    isLoading: (state) => {
        return (state.isLoading || state.isLoadingAgents);
    },

    isLoadingIfCanClaimTicket: (state) => {
        return state.isLoadingIfCanClaimTicket;
    },

    isLoadingAxumData: (state) => {
        return state.isLoadingAxumData;
    },

    isLoadingMedia: (state) => {
        return state.isLoadingMedia;
    },

    isLoadingExpenses: (state) => {
        return state.isLoadingExpenses;
    },

    isLoadingAudits: (state) => {
        return state.isLoadingAudits;
    },

    isLoadingOfficeTransfers: (state) => {
        return state.isLoadingOfficeTransfers;
    },

    isLoadingTagTemplates: (state) => {
        return state.isLoadingTagTemplates;
    },

    isLoadingRelatedTickets: (state) => {
        return state.isLoadingRelatedTickets;
    },

    canClaimTicket: (state) => {
        return state.canClaimTicket;
    },

    ticket: (state) => {
        return state.ticket;
    },

    agents: (state) => {
        return state.agents;
    },

    media: (state) => {
        return state.media;
    },

    expenses: (state) => {
        return state.expenses;
    },

    audits: (state) => {
        return state.audits;
    },

    officeTransfers: (state) => {
        return state.officeTransfers;
    },

    tagTemplates: (state) => {
        return state.tagTemplates;
    },

    relatedTickets: (state) => {
        return state.relatedTickets;
    },

    selectedAction: (state) => {
        return state.selectedAction
    },

    updateKey: (state) => {
        return state.updateKey
    },

    timelineUpdateKey: (state) => {
        return state.timelineUpdateKey
    },

    sidebarSection: (state) => {
        return state.sidebarSection;
    },

    axumData: (state) => {
        return state.axumData;
    },

    showDeleted: (state) => {
        return state.showDeleted;
    },

    bookmarks: (state, getters) => {
        if (!state.ticket) {
            return [];
        }

        let bookmarks = [];

        if (getters.expenses) {
            let bookmarked = _.filter(getters.expenses, (el) => {
                return el.bookmark;
            });
            _.each(bookmarked, (el) => {
                bookmarks.push({
                    type: 'TicketExpense',
                    id: el.id,
                    title: el.bookmark,
                    created_at: el.created_at
                });
            });
        }

        if (state.ticket.ticket_notes) {
            let bookmarked = _.filter(state.ticket.ticket_notes, (el) => {
                return el.bookmark;
            });
            _.each(bookmarked, (el) => {
                bookmarks.push({
                    type: 'TicketNote',
                    id: el.id,
                    title: el.bookmark,
                    created_at: el.created_at
                });
            });
        }

        if (state.ticket.ticket_forwarding_logs) {
            let bookmarked = _.filter(state.ticket.ticket_forwarding_logs, (el) => {
                return el.bookmark;
            });
            _.each(bookmarked, (el) => {
                bookmarks.push({
                    type: 'TicketForwardingLog',
                    id: el.id,
                    title: el.bookmark,
                    created_at: el.created_at
                });
            });
        }

        if (state.ticket.ticket_replies) {
            let bookmarked = _.filter(state.ticket.ticket_replies, (el) => {
                return el.bookmark;
            });
            _.each(bookmarked, (el) => {
                bookmarks.push({
                    type: 'TicketReply',
                    id: el.id,
                    title: el.bookmark,
                    created_at: el.created_at
                });
            });
        }

        if (state.ticket.inbound_emails) {
            let bookmarked = _.filter(state.ticket.inbound_emails, (el) => {
                return el.bookmark;
            });
            _.each(bookmarked, (el) => {
                bookmarks.push({
                    type: 'InboundEmail',
                    id: el.id,
                    title: el.bookmark,
                    created_at: el.created_at
                });
            });
        }

        if (state.ticket.inbound_text_messages) {
            let bookmarked = _.filter(state.ticket.inbound_text_messages, (el) => {
                return el.bookmark;
            });
            _.each(bookmarked, (el) => {
                bookmarks.push({
                    type: 'InboundTextMessage',
                    id: el.id,
                    title: el.bookmark,
                    created_at: el.created_at
                });
            });
        }

        if (state.ticket.ticket_sms_logs) {
            let bookmarked = _.filter(state.ticket.ticket_sms_logs, (el) => {
                return el.bookmark;
            });
            _.each(bookmarked, (el) => {
                bookmarks.push({
                    type: 'TicketSmsLog',
                    id: el.id,
                    title: el.bookmark,
                    created_at: el.created_at
                });
            });
        }

        bookmarks = _.sortBy(bookmarks, (el) => {
            return el.created_at;
        });

        return bookmarks;
    }
};

export const actions = {
    loadTicket({ commit, getters, dispatch }, id) {
        commit('START_LOADING');
        commit('SET_ERRORS', []);

        // Load tag templates
        dispatch('loadTagTemplates');

        // Clear the ticket if we had a previously loaded ticket and we are loading a different ticket
        if (getters.ticket !== null && getters.ticket.id !== id) {
            commit('SET_TICKET', null);
            commit('SET_SELECTED_ACTION', null);
        }

        let resource = API_BASE + '/tickets/' + id;

        if (getters.showDeleted) {
            resource = resource + '?include_deleted=1';
        }

        axios.get(resource).then(r => {
            commit('STOP_LOADING');
            commit('SET_TICKET', r.data);
            commit('INCREMENT_UPDATE_KEY');
            dispatch('loadAxumData');
            dispatch('loadMedia');
            dispatch('loadRelatedTickets');
            dispatch('loadIfCanClaimTicket');
            dispatch('loadExpenses');
        }).catch(e => {
            commit('STOP_LOADING');

            let errors;
            if (typeof e.response.data === 'object') {
                errors = _.flatten(_.toArray(e.response.data.errors));
            } else {
                errors = ['Something went wrong. Please try again.'];
            }
            commit('SET_ERRORS', errors);
        });
    },

    loadIfCanClaimTicket({ commit, getters }) {
        commit('START_LOADING_IF_CAN_CLAIM_TICKET');
        commit('SET_CAN_CLAIM_TICKET', null);
        commit('SET_ERRORS', []);

        axios.post(API_BASE + '/tickets/' + getters.ticket.id + '/can-claim').then(r => {
            commit('STOP_LOADING_IF_CAN_CLAIM_TICKET');
            commit('SET_CAN_CLAIM_TICKET', r.data);
        }).catch(e => {
            console.log(e);
            commit('STOP_LOADING_IF_CAN_CLAIM_TICKET');

            let errors;
            if (typeof e.response.data === 'object') {
                errors = _.flatten(_.toArray(e.response.data.errors));
            } else {
                errors = [];
            }
            commit('SET_ERRORS', errors);
        });
    },

    loadAgents({ commit, getters }) {
        commit('START_LOADING_AGENTS');
        commit('SET_ERRORS', []);

        axios.get(API_BASE + '/users/').then(r => {
            commit('STOP_LOADING_AGENTS');
            commit('SET_AGENTS', r.data);
            commit('INCREMENT_UPDATE_KEY');
        }).catch(e => {
            commit('STOP_LOADING_AGENTS');

            let errors;
            if (typeof e.response.data === 'object') {
                errors = _.flatten(_.toArray(e.response.data.errors));
            } else {
                errors = ['Something went wrong. Please try again.'];
            }
            commit('SET_ERRORS', errors);
        });
    },

    loadMedia({ commit, getters }) {
        commit('START_LOADING_MEDIA');
        commit('SET_ERRORS', []);

        axios.get(API_BASE + '/tickets/' + getters.ticket.id + '/media').then(r => {
            commit('STOP_LOADING_MEDIA');
            commit('SET_MEDIA', r.data);
            commit('INCREMENT_UPDATE_KEY');
        }).catch(e => {
            commit('STOP_LOADING_MEDIA');

            let errors;
            if (typeof e.response.data === 'object') {
                errors = _.flatten(_.toArray(e.response.data.errors));
            } else {
                errors = ['Something went wrong. Please try again.'];
            }
            commit('SET_ERRORS', errors);
        });
    },

    loadExpenses({ commit, getters }) {
        commit('START_LOADING_EXPENSES');
        commit('SET_ERRORS', []);

        axios.get(API_BASE + '/tickets/' + getters.ticket.id + '/expenses').then(r => {
            commit('STOP_LOADING_EXPENSES');
            commit('SET_EXPENSES', r.data);
            commit('INCREMENT_UPDATE_KEY');
        }).catch(e => {
            commit('STOP_LOADING_EXPENSES');

            let errors;
            if (typeof e.response.data === 'object') {
                errors = _.flatten(_.toArray(e.response.data.errors));
            } else {
                errors = ['Something went wrong. Please try again.'];
            }
            commit('SET_ERRORS', errors);
        });
    },

    loadAudits({ commit, getters }) {
        commit('START_LOADING_AUDITS');
        commit('SET_ERRORS', []);

        axios.get(API_BASE + '/tickets/' + getters.ticket.id + '/audits').then(r => {
            commit('STOP_LOADING_AUDITS');
            commit('SET_AUDITS', r.data);
            commit('INCREMENT_UPDATE_KEY');
        }).catch(e => {
            commit('STOP_LOADING_AUDITS');

            let errors;
            if (typeof e.response.data === 'object') {
                errors = _.flatten(_.toArray(e.response.data.errors));
            } else {
                errors = ['Something went wrong. Please try again.'];
            }
            commit('SET_ERRORS', errors);
        });
    },

    loadOfficeTransfers({ commit, getters }) {
        commit('START_LOADING_OFFICE_TRANSFERS');
        commit('SET_ERRORS', []);

        axios.get(API_BASE + '/tickets/' + getters.ticket.id + '/office-transfers').then(r => {
            commit('STOP_LOADING_OFFICE_TRANSFERS');
            commit('SET_OFFICE_TRANSFERS', r.data);
            commit('INCREMENT_UPDATE_KEY');
        }).catch(e => {
            commit('STOP_LOADING_OFFICE_TRANSFERS');

            let errors;
            if (typeof e.response.data === 'object') {
                errors = _.flatten(_.toArray(e.response.data.errors));
            } else {
                errors = ['Something went wrong. Please try again.'];
            }
            commit('SET_ERRORS', errors);
        });
    },

    loadTagTemplates({ commit, getters }) {
        commit('START_LOADING_TAG_TEMPLATES');
        commit('SET_ERRORS', []);

        axios.get(API_BASE + '/tag-templates').then(r => {
            commit('STOP_LOADING_TAG_TEMPLATES');
            commit('SET_TAG_TEMPLATES', r.data);
            commit('INCREMENT_UPDATE_KEY');
        }).catch(e => {
            commit('STOP_LOADING_TAG_TEMPLATES');

            let errors;
            if (typeof e.response.data === 'object') {
                errors = _.flatten(_.toArray(e.response.data.errors));
            } else {
                errors = ['Something went wrong. Please try again.'];
            }
            commit('SET_ERRORS', errors);
        });
    },

    loadRelatedTickets({ commit, getters }) {
        commit('START_LOADING_RELATED_TICKETS');
        commit('SET_ERRORS', []);

        if (getters.ticket.axum_booking_id) {
            axios.post(API_BASE + '/tickets/get-tickets-related-to-axum-booking', {
                axum_booking_id: getters.ticket.axum_booking_id,
                exclude_ticket_id: getters.ticket.id
            }).then(r => {
                commit('STOP_LOADING_RELATED_TICKETS');
                commit('SET_RELATED_TICKETS', r.data);
                commit('INCREMENT_UPDATE_KEY');
            }).catch(e => {
                commit('STOP_LOADING_RELATED_TICKETS');

                let errors;
                if (typeof e.response.data === 'object') {
                    errors = _.flatten(_.toArray(e.response.data.errors));
                } else {
                    errors = ['Something went wrong. Please try again.'];
                }
                commit('SET_ERRORS', errors);
            });
        } else {
            commit('STOP_LOADING_RELATED_TICKETS');
            commit('SET_RELATED_TICKETS', []);
        }
    },

    selectAction({ commit }, action) {
        commit('SET_SELECTED_ACTION', action);
    },

    cancelAction({ commit }) {
        commit('SET_SELECTED_ACTION', null);
    },

    actionComplete({ commit, dispatch, getters }) {
        commit('SET_SELECTED_ACTION', null);
        dispatch('reloadTicket');
    },

    reloadTicket({ dispatch, commit, getters }) {
        // commit('INCREMENT_TIMELINE_UPDATE_KEY');
        dispatch('loadTicket', getters.ticket.id);
    },

    updateTicketPropertySilently({ commit }, params) {
        commit('UPDATE_TICKET_PROPERTY_SILENTLY', params);
        commit('INCREMENT_UPDATE_KEY');
    },

    setSidebarSection({ commit, dispatch, getters }, section) {
        if (getters.sidebarSection === section) {
            commit('SET_SIDEBAR_SECTION', null);
        } else {
            // if (section === 'axum') {
            //     dispatch('loadAxumData');
            // }
            // if (section === 'media') {
            //    dispatch('loadMedia');
            // }
            commit('SET_SIDEBAR_SECTION', section);
        }
    },

    loadAxumData({ commit, getters, dispatch }) {
        commit('START_LOADING_AXUM_DATA');
        commit('SET_ERRORS', []);

        axios.get(API_BASE + '/tickets/' + getters.ticket.id + '/axum').then(r => {
            commit('STOP_LOADING_AXUM_DATA');
            commit('SET_AXUM_DATA', r.data);
            commit('INCREMENT_UPDATE_KEY');
            // dispatch('checkIfLeadPaxMatchesPrimaryContact');
        }).catch(e => {
            commit('STOP_LOADING_AXUM_DATA');

            let errors;
            if (typeof e.response.data === 'object') {
                errors = _.flatten(_.toArray(e.response.data.errors));
            } else {
                errors = ['Something went wrong. Please try again.'];
            }
            commit('SET_ERRORS', errors);
        });
    },

    checkIfLeadPaxMatchesPrimaryContact({ getters, dispatch }) {
        let vm = this;
        let axumData = getters.axumData;
        let leadPax = null;
        if (axumData.leadPassengerId) {
            leadPax = _.first(axumData.passengers, {
                passengerId: axumData.leadPassengerId
            });
        }
        let primaryContact = getters.ticket.primary_contact;

        if (leadPax && primaryContact) {
            let firstNameMatches = leadPax.firstname === primaryContact.first_name;
            // let lastNameMatches = leadPax.lastname === primaryContact.last_name;
            let lastNameMatches = leadPax.surname === primaryContact.last_name;
            if (!firstNameMatches || !lastNameMatches) {

                swal({
                    title: "AXUM Lead PAX Doesn't Match Primary Contact",
                    text: "Would you like to update the primary contact?",
                    icon: "info",
                    buttons: {
                        cancel: "No",
                        confirm: "Yes"
                    }
                }).then((shouldUpdate) => {
                    if (shouldUpdate) {
                        axios.post(API_BASE + '/contacts/find-or-create', {
                            first_name: leadPax.firstname,
                            last_name: leadPax.surname,
                            email: leadPax.email
                        }).then(r => {
                            let contact = r.data;
                            axios.post(API_BASE + '/tickets/' + getters.ticket.id + '/contacts/' + contact.id, {
                                make_primary: true
                            }).then(() => {
                                vm._vm.$notify.success({
                                    title: 'Success!',
                                    message: 'Lead contact updated successfully'
                                });
                                dispatch('reloadTicket');
                            }).catch(e => {
                                console.log(e);
                            });
                        }).catch(e => {
                            console.log(e);
                        });
                    }
                });

            }
        }
    },

    setShowDeleted({ commit, dispatch }, val) {
        commit('SET_SHOW_DELETED', val);
        dispatch('reloadTicket');
    },

    updateLocalTask({ commit }, task) {
        commit('UPDATE_LOCAL_TASK', task);
        commit('INCREMENT_UPDATE_KEY');
    }
}
